import React, { useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
} from "reactstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { resetPassword } from "../../api/Auth";

const SetNewPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const email = location.state?.email;

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const handleReset = async () => {
    setErrorMsg("");
    setSuccessMsg("");

    if (!email || !newPassword || !confirmPassword) {
      setErrorMsg("All fields are required.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setErrorMsg("Passwords do not match.");
      return;
    }

    try {
      const res = await resetPassword(email, newPassword, confirmPassword);
      setSuccessMsg(res.message || "Password reset successfully.");

      // Navigate to login after short delay
      setTimeout(() => {
        navigate("/auth/login");
      }, 2000);
    } catch (error) {
      setErrorMsg(error.response?.data?.message || "Something went wrong.");
    }
  };

  return (
    <Col lg="5" md="7">
      <Card className="bg-secondary shadow border-0">
        <CardBody className="px-lg-5 py-lg-5">
          <Form role="form" onSubmit={(e) => e.preventDefault()}>
            <h3 className="text-center mb-4">Set New Password</h3>

            <FormGroup className="mb-3">
              <InputGroup className="input-group-alternative">
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="ni ni-lock-circle-open" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  placeholder="New Password"
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                />
              </InputGroup>
            </FormGroup>

            <FormGroup className="mb-3">
              <InputGroup className="input-group-alternative">
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="ni ni-lock-circle-open" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  placeholder="Confirm Password"
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
              </InputGroup>
            </FormGroup>

            <div className="text-center">
              <Button color="primary" type="button" onClick={handleReset}>
                Reset Password
              </Button>
            </div>

            {successMsg && (
              <div className="text-success text-center mt-3">{successMsg}</div>
            )}
            {errorMsg && (
              <div className="text-danger text-center mt-3">{errorMsg}</div>
            )}
          </Form>
        </CardBody>
      </Card>
    </Col>
  );
};

export default SetNewPassword;
